import moment from '@/moment-gp'
import clonedeep from "lodash.clonedeep";
import { mapActions, mapGetters } from "vuex";
import TaskManagementMixin from "@/components/Mixins/TaskManagement"

const log1 = (...args) => { console.log(...args) }

export default {
  data: () => ({
    dragTaskItemFrom: null
  }),
  mixins: [ TaskManagementMixin ],
  computed: {
    ...mapGetters("dayplanner", [
      "drag_item_type",
      "drag_item",
      'dayplan_virtual_offsets'
    ]),
  },
  methods: {
    ...mapActions("dayplanner", [
      "setDragItem",
      "setDragItemType",
      "setBacklogStatus",
    ]),
    onDragSessionStart(item) {
      log1('SessionManagement onDragSessionStart', item)
      this.setDragItem(item)
      this.setDragItemType('SESSION')
    },

    onDragSessionEnd(destination, test) {
      log1('onDragSessionEnd this.drag_item_type', this.drag_item_type, this.drag_item, test)

      if ( !this.drag_item || this.drag_item === undefined || !this.drag_item_placement) {
        console.warn("Dragged item, but not item defined.")
        return
      }

      let source = this.drag_item;
      // calculate sortidx
      //let draggablesList = destination.draggablesList;
      let sessionList = null
      console.log('this.drag_item_type', this.drag_item_type)
      if (this.drag_item_type === 'SESSION') {
        sessionList = clonedeep(destination.draggablesList).filter(session => session.sessionId && session.sessionId !== source.sessionId && session.sessionId !== null);
      } else {
        sessionList = clonedeep(destination.draggablesList).filter(session => session.sessionId);
      }

      log1('onDragSessionEnd sessionList', sessionList)

      let sortidx = this.drag_item_placement.sortidx
      let itemType = this.drag_item.type
      if (this.drag_item_type === 'SESSION') {
        //log1('onDragSessionEnd source', source, 'destination',destination, 'newIndex', newIndex, 'sortidx', sortidx, 'source.sessionId', source.sessionId, 'destination.dateString', destination.dateString)
        log1('onDragSessionEnd drag_item_placement', this.drag_item_placement)
        log1('onDragSessionEnd updating before it starts',this.dayplan_virtual_offsets)
        var dayplan_virtual_offsets = this.dayplan_virtual_offsets
        if (this.drag_item.just_dropped && this.drag_item_placement) {
          var sequenceItems = this.drag_item.sequenceItems
          var goalId = this.drag_item.config.goalId
          var commitmentId = this.drag_item.config.commitmentId
          var userId = this.$models.user.defaultUserId
          var that = this
          if (this.drag_item.type === 'SEQUENCE') {
            itemType = 'TASKLIST'
           // delete this.drag_item.config
          }
          this.$models.userDayplannerSessions.add({
            dateString:    destination.dateString,
            from:          this.drag_item_placement.from,
            to:            this.drag_item_placement.to,
            type:          itemType,
            commitmentId:  this.drag_item.config.commitmentId,
            tasks:         [],
            sortidx:       sortidx,
            createdAt:     moment.currentTime().unix(),
            config:        this.drag_item.config
          }).then(sourceSessionId => {

            // Show backlog
            this.setBacklogStatus({ sessionId: sourceSessionId, status: true });

            if ( sequenceItems ) {
              //console.log('onAddItem new sesionId', sessionId)
              sequenceItems.forEach(sequenceItem => {
                console.log('adding sequencsequenceItem pre')
                that.$api.task_create_user({
                  goal_id: goalId,
                  parent_id: commitmentId,
                  member_id: userId,
                  data: {
                    sortidx: 1, // HACK !!! get_last_sortidx, won't work
                    name: sequenceItem.cachedTitle,
                    sessionId: sourceSessionId,
                    durationRemaining: sequenceItem.duration
                  }
                }).then((taskId) => {
                  //console.log('onAddItem new taskId', taskId)
                  console.log('adding sequencetask', {
                    seqRound: sequenceItem.sequenceRound,
                    seqItemId: sequenceItem.sequenceItemId,
                    taskId: taskId })
                  this.$models.commitmentSequenceTasks
                    .with({
                      goalId: goalId,
                      uid: userId
                    })
                    .add({
                      seqRound: sequenceItem.sequenceRound,
                      seqItemId: sequenceItem.sequenceItemId,
                      taskId: taskId,
                    })
                  that.onAddTaskToSession({
                    goalId: goalId,
                    memberId: userId,
                    taskId: taskId,
                    tasksInSession: [],
                    sessionId: sourceSessionId,
                  });
                });
              })
            }
            // update all sessions that were moved
            Object.keys(dayplan_virtual_offsets).forEach(sessionId => {
              //log1('onDragSessionEnd marker1', sessionId)
              let session = dayplan_virtual_offsets[sessionId]
              if (sessionId && sessionId !== 'undefined' && (!sourceSessionId || sessionId !== sourceSessionId)) {
                if (session.newFrom && session.newTo && session.type === 'TASKLIST') {
                  this.$models.userDayplannerSessions
                  .update(sessionId, {
                    from: session.newFrom,
                    to: session.newTo,
                  });
                }
              }
            })
          })
          log1('source.sessionId', source.sessionId)

        } else if (this.drag_item_type === 'SESSION' && this.drag_item_placement) {
          log1('onDragSessionEnd vars', source.sessionId, sortidx, destination.dateString, this.drag_item_placement.from, this.drag_item_placement.to)
          console.log('typeof', typeof sortidx, typeof destination.dateString, typeof this.drag_item_placement.from ,typeof this.drag_item_placement.to )
          this.$models.userDayplannerSessions
          .update(source.sessionId, {
            sortidx: sortidx,
            dateString: destination.dateString,
            from: this.drag_item_placement.from,
            to: this.drag_item_placement.to,
          }).then(() => {
          // update all sessions that were moved
            Object.keys(dayplan_virtual_offsets).forEach(sessionId => {
              let session = dayplan_virtual_offsets[sessionId]
              if (sessionId && sessionId !== 'undefined' && (!source.sessionId || sessionId !== source.sessionId)) {
                if (session.newFrom && session.newTo && session.type === 'TASKLIST') {
                  this.$models.userDayplannerSessions
                  .update(sessionId, {
                    from: session.newFrom,
                    to: session.newTo,
                  });
                }
              }
            })
          })
        }
      }

      if (this.drag_item_type === 'TASK') {
        /*this.$models.userDayplannerSessions
        .update(source.sessionId, {
          sortidx: sortidx,
          dateString: destination.dateString
        });*/

        let item = {
          from: this.drag_item_placement.from,
          to: this.drag_item_placement.to,
          type: 'TASKLIST',
          commitmentId: source.listId,
          tasks: [],
        }
        /*let tasks = [
          {
            taskId: source.taskId,
            from: item.from,
            duration: source.taskDuration,
            cachedTitle: source.cachedTitle,
            cachedFinishedAt: null
          }
        ]*/
        log1('onDragSessionEnd CREATING NEW SESSION for task item', item, 'sortidx:', sortidx, 'destination', destination)
        this.$models.userDayplannerSessions.add({
          dateString:    destination.dateString,
          from:          item.from, // in seconds
          to:            item.to,
          type:          item.type,
          commitmentId:  item.commitmentId,
          tasks:         [],
          sortidx:       sortidx,
          createdAt:     moment.currentTime().unix()
        }).then(sessionId => {
          this.onAddTaskToSession({
            goalId: source.goalId,
            memberId: source.memberId, // TODO: needs to be changed to destination
            taskId: source.taskId,
            tasksInSession: [],
            sessionId: sessionId
          })
        });
      }

      this.setDragItem(null)
      this.setDragItemType(null)
      this.setDragTimeActive(false)
    },

    onDragTimeEnd() {
      // update all sessions that were moved
      Object.keys(this.dayplan_virtual_offsets).forEach(sessionId => {
        let session = this.dayplan_virtual_offsets[sessionId]
        //log1('onDragTimeEnd', sessionId, session.newFrom, session.newTo)
        if (session.newFrom && session.newTo) {
          this.$models.userDayplannerSessions
          .update(sessionId, {
            from: session.newFrom,
            to: session.newTo,
          });
        }
      })
    },

    removeSession(item) {
      log1("onRemoveItem", item)

      //let idx = item.original_idx;

      if ( item.sessionId === undefined ) {
        console.warn("original_idx not given.");
        return false;
      }

      // Do not allow to delete START_DAY or END_DAY
      if ( item.type === "START_DAY" || item.type === "END_DAY" ) {
        return false;
      }

      //log1("onRemoveItem - item, org_idx, item@idx", item, idx, this.dayplan_from_db[idx]);
      //this.createSnapshot(this.dayplan_from_db);
      log1("removing session", item.sessionId);
      log1("onRemoveItem item", item);

      // remove all attached tasks
      if (item.type === 'TASKLIST') {
        let commitment = this.$models.commitment
        .with({ goalId: item.config.goalId })
        .subscribeNode(item.config.commitmentId);

        item.tasks.forEach(task => {
          log1(
            "onRemoveItem task",
            task,
            "commitment.meta.assignedUserId",
            commitment.meta.assignedUserId,
            "data",
            {
              member_id: commitment.meta.assignedUserId,
              goal_id: item.config.goalId,
              task_id: task.taskId,
              data: { sessionId: null },
            }
          );
          this.$api.task_update({
            member_id: commitment.meta.assignedUserId,
            goal_id: item.config.goalId,
            task_id: task.taskId,
            data: { sessionId: null },
          });
          this.dayplanner_unfinished_tasks.forEach(item => {
            if (item.$state.taskId === task.taskId) {
              log1('removeSession', task.taskId)
              this.$models.userDayplannerTasks.remove(item.$id)
            }
          })
        });
      }
      this.$models.userDayplannerSessions.remove(item.sessionId); //item.sessionId);
    }
  }
}
